<div [class.container]="isMobileAppHeader">
  <ng-container *ngIf="!isMobileAppHeader else mobileHeaderControls">
    <i class="icon hamburger"> <svg    width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 6h20v2H2V6zM2 11h20v2H2v-2zM22 16H2v2h20v-2z" fill="#2E2E2E"/></svg> </i>
  </ng-container>

  <ng-template #mobileHeaderControls>
    <a *ngIf="backLink" class="mobile-back-icon" [routerLink]="backLink">
      <svg    width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#5E5E5E" d="M21.501 11.138v1.724h-19v-1.724z"/><path d="M11.182 19.281L9.964 20.5l-8.465-8.469 1.218-1.218 8.465 8.468z" fill="#5E5E5E"/><path fill="#5E5E5E" d="M10.027 3.5l1.218 1.219-8.528 8.531-1.218-1.218z"/></svg>
    </a>
  </ng-template>

  <div *ngIf="!isNavigating" class="breadcrumb">
    <ng-container *ngFor="let item of breadcrumb; let index = index; let last = last">
      <a *ngIf="item.commands" class="breadcrumb-link" [routerLink]="item.commands" data-e2e="breadcrumb-link">
        {{item.title}}
      </a>
      <a *ngIf="!item.commands" class="breadcrumb-active" [class.active]="last" data-e2e="breadcrumb-active">
        {{item.title}}
      </a>
      <div *ngIf="item.isBetaTag" class="beta-wrapper">
        <span class="beta-tag" i18n>BETA</span>
      </div>
      <i *ngIf="!last && breadcrumb[index + 1]?.title" class="chevron"> <svg    width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M.41 6.793L3.203 4 .41 1.207 1.117.5l3.5 3.5-3.5 3.5-.707-.707z" fill="#757575"/></svg> </i>
    </ng-container>
  </div>
</div>
